import appConfig from '../../appConfig';

const USstateConfig = {
	// Ohio
	OH: {
		stateName: 'Ohio',
		stateID: 'OH',
		tcLink: 'https://www.playup.com/ohio-terms-and-conditions/',
		privacyLink: 'https://www.playup.com/ohio-privacy-policy/',
		responsibleGamplingLink: 'http://playup.com/ohio-responsible-gaming',
		gamblingPhone: '1-800-589-9966',
		gamblingPhoneDisplay: '1-800-589-9966',
		gamblingSMS: '',
	},
	// Iowa
	IA: {
		stateName: 'Iowa',
		stateID: 'IA',
		tcLink: 'https://www.playup.com/iowa-terms-and-conditions/',
		privacyLink: 'https://www.playup.com/iowa-privacy-policy/',
		responsibleGamplingLink: 'https://www.playup.com/iowa-responsible-gaming/',
		gamblingPhone: '18002387633',
		gamblingPhoneDisplay: '1-800-BETS-OFF',
		gamblingSMS: '(855) 895-8398',
	},
}[appConfig.regions.usState as string] ?? {
	stateName: '',
	stateID: '',
	tcLink: '',
	privacyLink: '',
	gamblingPhone: '',
	gamblingPhoneDisplay: '',
	responsibleGamplingLink: '',
	gamblingSMS: '',
};

export default USstateConfig;
